import AbsModule from "../common/AbsModule";
import PurpleUserInfo from "./PurpleUserInfo";
import PurpleUrl from './PurpleUrl';
import { PLAYNC_DOMAIN } from '../common/const';

class PurpleBottomNav extends AbsModule {
    constructor(config) {
        super(config);
        
        this.purpleUserInfo = new PurpleUserInfo(config);
        //this.extendSession(); // 퍼플런처 세션 유지위해 15분 주기로 api 호출
        this.callSessionApi(); // cnb 생성 시 인증 확인 API 호출
    }

    startSetting() {
        this.purpleUserInfo.startSetting({
            parentType: PurpleUserInfo.PARENT_TYPE_BOTTOM_NAV,
            parent: document.querySelector('.ncc-purple-bottom-nav')
        });
    }

    makeMarkup() {
        return `<div class="ncc-purple-bottom-nav">
            ${this.purpleUserInfo.markUp}
        </div>`;
    }
    
    extendSession() {
        const { purpleCheck } = this.com || {};
        const { isPurpleLauncher } = purpleCheck;

        if(!isPurpleLauncher) {
            return;
        }

        const DURATION = 15;
        let timer;

        try {
            timer = setTimeout(() => {
                this.callSessionApi();
            }, DURATION * 60 * 1000);
        } catch(e) {
            console.error(e);
        }
    }

    callSessionApi() {
        const env = this.com?.env in PLAYNC_DOMAIN ? this.com?.env : 'live';
        const url = `${PLAYNC_DOMAIN[env]}/api/session/check`;

        fetch(url, {
            method: 'GET',
            credentials: 'include'
        })
        .then(res => res?.json())
        .then(res => {
            const { login = false } = res || {};

            if(login) {
                this.extendSession(); // 로그인되면 DURATION 주기로 호출
            } else {
                throw new Error(`퍼플 런처 세션 연장 api 호출에 실패하였습니다.`);
            }
        })
        .catch(e => {
            PurpleUrl.goErrorPage(env);
        });
    }
}

export default PurpleBottomNav;